// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  urlBackEnd : "https://apis.lifehero.dev.techland.link/web/",
  urlUploadBackEnd : 'https://upload.dev.techland.link/file/fileUploadClientSync',
  portBackEnd : "",
  capcha : "6LcLr2cjAAAAAIcbGTBeYlhCbYshpMoSfe_Y_v0y",
  asset : "https://s3-ap-southeast-1.amazonaws.com/fmarket-static/dev2",
};
